import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import Button from '../../fragments/button/Button.jsx';
import CardItem from './CardItem.jsx';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function CardCarouselSwiper({ cards = [], cardType }) {
  const swiperRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  // The Swiper instance reports its edge state on init and on every change.
  const syncEdges = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <>
      <div className={`carouselContainer ${isDragging ? 'is-dragging' : ''}`}>
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
            syncEdges(swiper);
          }}
          onSlideChange={syncEdges}
          onTouchStart={() => setIsDragging(true)}
          onTouchEnd={() => setIsDragging(false)}
          modules={[Navigation, Pagination]}
          pagination={{ clickable: true }}
          grabCursor={true}
          spaceBetween={24}
          slidesPerView={1.15}
          speed={600}
          breakpoints={{
            768: { slidesPerView: 2, spaceBetween: 8 },
            // A set of 3 or fewer fills this view, so Swiper locks itself and
            // there is nothing to drag — the grab cursor would be a lie.
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
              grabCursor: cards.length > 3,
            },
          }}
        >
          {cards.map((card, index) => (
            <SwiperSlide key={card.databaseId ?? index}>
              <CardItem card={card} cardType={cardType} index={index} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="CardCarousel-controls">
        <Button
          className="button--icon"
          aria-label="Previous Slide"
          icon="arrowRight"
          disabled={isBeginning}
          onClick={() => swiperRef.current?.slidePrev()}
        />
        <Button
          className="button--icon"
          aria-label="Next Slide"
          icon="arrowRight"
          disabled={isEnd}
          onClick={() => swiperRef.current?.slideNext()}
        />
      </div>
    </>
  );
}
